const videoWrappers = document.querySelectorAll('.video');

videoWrappers.forEach((videoWrapper) => {
    const video = videoWrapper.querySelector('video');
    const videoOverlay = videoWrapper.querySelector('.video__overlay');
    const playButton = videoWrapper.querySelector('.video__overlay-play-button');
    const isAutoplay = videoWrapper.dataset.autoplay === 'true';

    if (video) {
        video.muted = true;
    }

    if (playButton && !isAutoplay) {
        playButton.addEventListener('click', () => {
            video.play();
            video.removeAttribute('tabindex');
            videoOverlay.classList.add('d-none');
        });
    }
});

const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
};

const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        const video = entry.target.querySelector('video');
        const isAutoplay = entry.target.dataset.autoplay === 'true';

        if (!video) {
            return;
        }

        if (entry.isIntersecting && isAutoplay) {
            video.play().catch(() => {});
        } else if (!entry.isIntersecting && !video.paused) {
            video.pause();
        }
    });
}, observerOptions);

videoWrappers.forEach((videoWrapper) => {
    videoObserver.observe(videoWrapper);
});
